let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("22t2C")).then(() => parcelRequire('kfwSD'));